import { createContext } from 'react'
import { GoBackToEntry } from '../typings/GoBackToEntry'

export const AddEntryContext = createContext<(entry: GoBackToEntry) => void>(
  () => {}
)
